import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { EmptyState } from '@lumapps/lumx-states/components/EmptyState';
import { mdiBell } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { NOTIFICATIONS_CENTER } from '../../keys';

const CLASSNAME = 'notification-center-empty-list';

/**
 * Empty state when no notifications
 */
const NotificationEmptyList: React.FC = () => {
    const { translateKey } = useTranslate();
    const { block } = useClassnames(CLASSNAME);

    return (
        <EmptyState
            iconProps={{
                icon: mdiBell,
            }}
            title={translateKey(NOTIFICATIONS_CENTER.NO_NEW_NOTIFICATION)}
            wrapperProps={{ className: block() }}
        />
    );
};

export { NotificationEmptyList };
